import React, { useState } from "react";
import {
  Card,
  CardBody,
  Button,
  Badge,
  Alert,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import {
  MapPin,
  Bookmark,
  Share2,
  Calendar,
  Briefcase,
  DollarSign,
  Clock,
  Award,
  Users,
  ChevronRight,
  Link,
} from "react-feather";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const InteractiveJobCard = ({ JobsData }) => {
  const history = useNavigate();

  const [isBookmarked, setIsBookmarked] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const handleBookmark = () => {
    setIsBookmarked(!isBookmarked);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 2000);
  };

  const handleShare = () => {
    const currentUrl = window.location.href;
const msg = `Field Audit Job Opportunity at BetelJobs  

I came across this job opening for a **Field Auditor** at **BetelJobs** (by TRPW Strategic Partners), and I thought it might be a great fit for you or someone in your network with experience in field audits.  

📍 **Upcoming Audit in**: ${JobsData?.fld_city || "City"}, ${JobsData?.fld_state || "State"}  

### **Audit Details:**
➡️ **Audit ID**: ${JobsData?.fld_code || "N/A"}  
➡️ **Nature of Audit**: ${JobsData?.fld_title || "N/A"}  
➡️ **Qualification Required**: ${JobsData?.fld_qualification || "N/A"}  
➡️ **Experience Required**: ${exp({
      min: JobsData?.fld_minexperience || 0,
      type: JobsData?.fld_experiencetype || "Years",
    })}  
➡️ **No. of Resources Required**: ${JobsData?.fld_positions || "N/A"}  
➡️ **Start Date**: ${moment(JobsData?.fld_auditdate).format('ll') || "N/A"}  
➡️ **Duration of Assignment**: ${JobsData?.fld_assignduration || "N/A"} days  
➡️ **Industry**: ${JobsData?.fld_area || "N/A"}  
➡️ **Location**: ${JobsData?.fld_city || "N/A"}, ${JobsData?.fld_state || "N/A"}  
➡️ **Budget Range**: ₹${JobsData.fld_minsalary} - ₹${JobsData.fld_maxsalary} ${JobsData.fld_salarytype}  
➡️ **Vehicle Required**: ${JobsData?.fld_vehicle || "No"}  
➡️ **Remote Work**: ${JobsData?.fld_remotework ? "Yes" : "No"}  
➡️ **Laptop Required**: ${JobsData?.fld_laptop ? "Yes" : "No"}  
➡️ **Full Audit Location**: ${JobsData?.fld_address || "N/A"}  

🔗 **Click here to apply**: ${currentUrl}  

If this sounds interesting, feel free to apply or share it with someone who might be a good fit.  

📩 **For more details, contact us at:**  
✉️ support@beteljobs.com  
📞 9319179297  
`;
    // if (navigator.share) {
    //   navigator.share({
    //     title: JobsData?.fld_title,
    //     text: msg,
    //     // url: window.location.href,
    //   });
    // }
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(msg)}`;
    window.open(whatsappUrl, "_blank");
  };

  const showDetailHandler = (data) => {
    window.open(
      `/jobdetails/${data?.fld_id}/${data?.fld_title?.replace(/\W|_/g, "")}`,
      "_blank"
    );
    // history.push({
    //     pathname: `/jobdetails/${data?.fld_id}/${data?.fld_title?.replace(
    //         /\W|_/g,
    //         ""
    //     )}`,
    //     state: data?.fld_id,
    // });
  };

  const exp = ({ max, min, type }) => {
    let temp = "";
    if (min >= 0 && max) {
      return `${min} - ${max} ${type}`;
    }
    if (min == 0) {
      return `Fresher & Above`;
    }
    if (min) {
      return `${min}+ ${type}`;
    }
  };

  return (
    <div className="position-relative" style={{ marginBottom: "2px" }}>
      {/* Alert */}
      {/* Job Card */}
      <Card className="shadow-sm hover-shadow-lg transition-all border-0">
        <CardBody>
          {/* Header Section */}
          <Row className="align-items-center">
            <Col>
              <h3 className="h5">
                <a
                  href="#"
                  className="text-decoration-none text-dark hover-primary d-flex align-items-center text-capitalize"
                >
                  {JobsData?.fld_title}
                  {JobsData?.is_featured && (
                    <Badge color="warning" className="ms-2">
                      Featured
                    </Badge>
                  )}
                </a>
              </h3>
            </Col>
            <Col xs="auto">
              <div className="d-flex gap-2">
                <Button
                  color="light"
                  className="btn-icon p-2"
                  onClick={handleShare}
                  id="shareBtn"
                >
                  <Share2 size={18} className="text-muted" />
                </Button>
                <UncontrolledTooltip target="shareBtn">
                  Share job
                </UncontrolledTooltip>
              </div>
            </Col>
          </Row>
          <p
            className="text-muted d-flex align-items-center mb-2"
            style={{ marginTop: "-10px" }}
          >
            <Briefcase size={16} className="mr-2" />
            <a
              href="#"
              className="text-decoration-none text-muted hover-primary"
            >
              {exp({
                min: JobsData.fld_minexperience,
                type: JobsData.fld_experiencetype,
                max: JobsData.fld_maxexperience,
              })}
            </a>
          </p>
          <div className="d-flex justify-content-between mb-2">
            <span
              className="px-2 py-1"
              style={{
                color: "#c16d18",
                border: "1px solid #c16d18",
                borderRadius: "5px",
                fontSize: "12px",
              }}
            >
              {JobsData?.fld_type}
            </span>
            <span
              className="px-2 py-1"
              style={{
                color: "#c16d18",
                border: "1px solid #c16d18",
                borderRadius: "5px",
                fontSize: "12px",
                maxWidth: "150px", // Adjust width as needed
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
              }}
              title={`${JobsData?.fld_city || "N/A"}, ${
                JobsData?.fld_state || "N/A"
              }`} // Show full text on hover
            >
              <MapPin size={12} className="mr-1" />
              {`${JobsData?.fld_city || "N/A"}, ${
                JobsData?.fld_state || "N/A"
              }`}
            </span>

            <span
              className="px-2 py-1"
              style={{
                color: "#c16d18",
                border: "1px solid #c16d18",
                borderRadius: "5px",
                fontSize: "12px",
              }}
            >
              Position : {JobsData?.fld_positions}
            </span>
          </div>

          {/* Action Buttons */}
          <div className="d-flex justify-content-between mt-4">
            <div
              className="d-flex align-items-center text-muted"
              style={{ fontSize: "12px" }}
            >
              {/* <Clock size={16} className="mr-2" />
              <span>Posted {JobsData?.fld_posted_date || "2 days ago"}</span> */}
            </div>
            <span
              onClick={() => showDetailHandler(JobsData)}
              className="px-2 py-1"
              style={{
                color: "#fff",
                background: "#c16d18",
                borderRadius: "5px",
                fontSize: "12px",
                cursor: "pointer",
              }}
            >
              View Details
            </span>
          </div>
        </CardBody>
      </Card>

      {/* Custom CSS */}
      <style>
        {`
          .hover-shadow-lg {
            transition: all 0.3s ease-in-out;
          }
          .hover-shadow-lg:hover {
            transform: translateY(-2px);
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
          }
          .hover-primary:hover {
            color: #0d6efd !important;
          }
          .btn-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
          }
          .transition-all {
            transition: all 0.3s ease-in-out;
          }
          .badge {
            font-weight: 500;
          }
        `}
      </style>
    </div>
  );
};

export default InteractiveJobCard;
